<div class="footer">
    Copyrights &#64; 2025 Canarys | All rights reserved
</div>
